export const SCHOOL_FEES = {
  LKG: 7000,
  UKG: 7000,
  1: 8000,
  2: 9000,
  3: 10000,
  4: 11000,
  5: 15000,
  6: 15000,
  7: 18000,
  8: 18000,
};

export const VAN_FEE_OPTIONS = [
  { value: 'Dindawar: ₹3000', label: 'Dindawar: ₹3000' },
  { value: 'Satihal: ₹4000', label: 'Satihal: ₹4000' },
  { value: 'Aralichandi: ₹4000', label: 'Aralichandi: ₹4000' },
  { value: 'Ramanahatti: ₹4000', label: 'Ramanahatti: ₹4000' },
  { value: 'K. Salawadagi: ₹4000', label: 'K. Salawadagi: ₹4000' },
  { value: 'Gulabal: ₹4000', label: 'Gulabal: ₹4000' },
  { value: 'Budihal: ₹2500', label: 'Budihal: ₹2500' },
  { value: 'Kamanakeri: ₹2000', label: 'Kamanakeri: ₹2000' },
  { value: 'Budihal L.T: ₹3000', label: 'Budihal L.T: ₹3000' },
  { value: 'Ballavur: ₹5500', label: 'Ballavur: ₹5500' },
  { value: 'Ingaleshwar: ₹4000', label: 'Ingaleshwar: ₹4000' },
  { value: 'No: ₹0', label: 'No: ₹0' },
];

export function getSchoolFee(className) {
  return SCHOOL_FEES[className] ?? 0;
}
